// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ngb-alert {
  position: fixed;
  bottom: 24px;
  right: 16px;
  left: unset;
  z-index: 1000;
  margin-bottom: unset;
  border-color: transparent;
}
@media (max-width: 767px) {
  ngb-alert {
    left: 16px;
    max-height: 250px;
    overflow-y: auto;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/toast/toast.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;AACF;AAAE;EARF;IASI,UAAA;IACA,iBAAA;IACA,gBAAA;EAGF;AACF","sourcesContent":["ngb-alert {\n  position: fixed;\n  bottom: 24px;\n  right: 16px;\n  left: unset;\n  z-index: 1000;\n  margin-bottom: unset;\n  border-color: transparent;\n  @media (max-width: 767px) {\n    left: 16px;\n    max-height: 250px;\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
